import { render, staticRenderFns } from "./cropType.vue?vue&type=template&id=6138e570&scoped=true"
import script from "./cropType.vue?vue&type=script&lang=js"
export * from "./cropType.vue?vue&type=script&lang=js"
import style0 from "./cropType.vue?vue&type=style&index=0&id=6138e570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6138e570",
  null
  
)

export default component.exports